export const route = { patterns: { dashboardV2: '/dashboard-v2' } };
